__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "root";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vmos2/core", "0.4.1", () => (Promise.all([__webpack_require__.e("shared-root-index"), __webpack_require__.e("Vendors-root"), __webpack_require__.e("vendors-node_modules_vmos2_core_src_index_ts"), __webpack_require__.e("node_modules_date-fns_locale_lazy_recursive_af_7Car_7Car-DZ_7Car-EG_7Car-MA_7Car-SA_7Car-TN_7-422cfa")]).then(() => (() => (__webpack_require__(99496))))));
			register("i18next", "19.9.2", () => (Promise.all([__webpack_require__.e("shared-root-i18next"), __webpack_require__.e("Vendors-root")]).then(() => (() => (__webpack_require__(65262))))));
			register("react-i18next", "11.18.6", () => (Promise.all([__webpack_require__.e("shared-root-index"), __webpack_require__.e("Vendors-root"), __webpack_require__.e("vendors-node_modules_react-i18next_dist_es_I18nextProvider_js-node_modules_react-i18next_dist-49b725"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(80723))))));
			register("react", "16.14.0", () => (Promise.all([__webpack_require__.e("shared-root-index"), __webpack_require__.e("Vendors-root"), __webpack_require__.e("node_modules_react_cjs_react_production_min_js")]).then(() => (() => (__webpack_require__(30969))))));
			register("single-spa-layout", "2.2.0", () => (Promise.all([__webpack_require__.e("shared-root-single-spa-layout.min"), __webpack_require__.e("webpack_sharing_consume_default_single-spa_single-spa")]).then(() => (() => (__webpack_require__(21882))))));
			register("single-spa", "5.9.5", () => (__webpack_require__.e("shared-root-single-spa.min").then(() => (() => (__webpack_require__(49044))))));
			register("single-spa", "6.0.0", () => (__webpack_require__.e("shared-root-single-spa.min").then(() => (() => (__webpack_require__(91998))))));
			initExternal(46291);
			initExternal(89217);
			initExternal(13482);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};